import TagDetail from './TagDetail'

export default TagDetail
